import React from 'react'
import {
   AIBigDataIcon,
   AIDrivenSmartTravelIcon,
   AIPoweredCustomerIcon,
   ContinuousSupportIcon,
   CustomHospitalitySoftwareIcon,
   CustomTailoredTravelIcons,
   OmnichannelTravelIcon,
   OmnichannelUserExperienceIcon,
   ScalableCloudBasedIcon,
   ScalableSolutionsIcon,
   SeamlessIntegrationIcon,
   SecureCompliantPlatformsIcon,
   SecureTransactionsIcon,
   TailoredRealEstateIcon,
} from '@/svgs'
import { WhyChooseOur } from '@/components'

const featureCards = [
   {
      title: 'Custom-Tailored Real Estate Solutions',
      subtitle: 'Designed for Agents, Brokers & Property Managers',
      description:
         'We craft bespoke real estate software, such as MLS sites, AI-driven listing websites, and CRM solutions, to provide efficient transactions and lead management.',
      icon: <TailoredRealEstateIcon />,
   },
   {
      title: 'AI & Big Data for Market Insights',
      subtitle: 'Data-Driven Real Estate Decision-Making',
      description:
         'We provide AI-based analytics and forecasting models that present up-to-the-minute market patterns, property prices projection, and competitiveness analysis that enables real estate agents.',
      icon: <AIBigDataIcon />,
   },
   {
      title: 'Secure & Compliant Real Estate Platforms',
      subtitle: 'Ensuring Data Protection & Compliance',
      description:
         'We ensure GDPR, CCPA, and real estate compliance standards, implementing blockchain-based smart contracts and encryption protocols for secure transactions.',
      icon: <SecureCompliantPlatformsIcon />,
   },
   {
      title: 'Omnichannel User Experience',
      subtitle: 'Seamless Property Search Across Devices',
      description:
         'We design web-optimized and mobile-based real estate products, so one can experience seamless and rich property searchability on various mediums.',
      icon: <OmnichannelUserExperienceIcon />,
   },
   {
      title: 'Scalable Cloud-Based Infrastructure',
      subtitle: 'Optimized for Performance & Growth',
      description:
         'Our cloud-based real estate platforms support real-time property updates, multi-agent management, and scalable storage, enabling businesses to expand without limitations.',
      icon: <ScalableSolutionsIcon />,
   },
   {
      title: 'Continuous Support & Enhancements',
      subtitle: 'Ensuring Future-Ready Real Estate Solutions',
      description:
         'We provide ongoing system monitoring, security updates, and feature improvements to keep real estate platforms competitive, secure, and aligned with market trends.',
      icon: <ContinuousSupportIcon />,
   },
]; 

function TravelWhyChoose() {
   return (
      <>
         <WhyChooseOur
            title={'Why Choose Our Real Estate Software Development Services?'}
            desc={
               'We create safe, scalable, and cutting-edge real estate solutions that optimize property management, customer interaction, and transaction flow. Here’s why businesses choose Benzatine:'
            }
            cardData={featureCards}
            // otherUi={true}
         />
      </>
   )
}

export default TravelWhyChoose
